import FilledButtonM from "@common/components/button/FilledButtonM"
import TextM from "@common/components/text/TextM"
import { ModalSkeleton } from "@common/modals/ModalSkeleton"
import { theme } from "@common/theme/theme"
import React from "react"
import { View } from "react-native"

/**
 * A single reusable bottom-sheet for « Ma dispo » informational / confirmation
 * flows: the attribution education sheet, the continuity engagement warning, and
 * the starting-date change warning.
 *
 * Copy only, no ornament: the sheet used to open on a 56 px icon medallion above
 * the text, which reads as the primary control of the dialog — centred, coloured,
 * the size of a button — and is not tappable at all. The title carries the meaning.
 *
 * `body` is any renderable node (so callers can bold parts of the copy).
 * When `onConfirm` is provided the sheet is a confirm/cancel dialog; otherwise
 * it's a single « J'ai compris » acknowledgement.
 *
 * `onCancel` splits the cancel BUTTON from the × / backdrop when the two must
 * differ — an unsaved-changes sheet whose cancel leaves without saving, while
 * closing the sheet keeps the tutor on the screen. It defaults to `onClose`.
 */
export const MaDispoInfoSheet = ({
    visible,
    onClose,
    title,
    body,
    confirmLabel,
    onConfirm,
    confirmColor,
    cancelLabel = "Annuler",
    onCancel,
    loading,
}) => {
    return (
        <ModalSkeleton isVisible={visible} onClose={onClose} title={title}>
            <View style={{ alignItems: "center", paddingBottom: 8 }}>
                {typeof body === "string" ? (
                    <TextM
                        wrap
                        fontSize={14}
                        color={theme.colors.grey}
                        style={{ textAlign: "center", lineHeight: 21 }}
                    >
                        {body}
                    </TextM>
                ) : (
                    body
                )}

                <View style={{ height: 18 }} />

                {/* `width: 100%` : sans elle, FilledButtonM se dimensionne sur
                    la largeur d'écran et déborde la carte, qui le rogne. */}
                {onConfirm ? (
                    <>
                        <FilledButtonM
                            label={confirmLabel ?? "Confirmer"}
                            color={confirmColor}
                            loading={loading}
                            onPress={onConfirm}
                            style={{ width: "100%" }}
                        />
                        <FilledButtonM
                            mode="outlined"
                            label={cancelLabel}
                            color={theme.colors.primary}
                            onPress={onCancel ?? onClose}
                            style={{ width: "100%" }}
                        />
                    </>
                ) : (
                    <FilledButtonM
                        label={confirmLabel ?? "J'ai compris"}
                        onPress={onClose}
                        style={{ width: "100%" }}
                    />
                )}
            </View>
        </ModalSkeleton>
    )
}
